module.exports = __webpack_public_path__ + "img/95.6997ca07.png";